import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription, throwError } from 'rxjs';
import { catchError, filter, switchMap, tap } from 'rxjs/operators';
import { LoginForm } from 'src/app/shared/forms/auth/login.form';
import { AuthStoreService } from 'src/app/shared/services/auth/auth-store.service';
import { AuthApiService } from 'src/app/shared/services/auth/auth.api.service';
import { AnalyticsFormService } from '../../../core/services/analytics-form.service';
import { AnalyticsService } from '../../../core/services/analytics-service';
import { AppCookiesService } from '../../../core/services/app-cookies.service';
import { SavedUrlService } from '../../../core/services/saved-url.service';
import { CartSuggestionService } from '../../../pay/services/cart-suggestion.service';
import { LoginService } from '../../../shared/services/auth/login.service';
import { OnboardingService } from '../../../onboarding/services/onboarding.service';
import { AppConfig } from '../../../core/services/app-config.service';
import { ConfigurationState } from '../../../core/enums/configuration-state.enum';
import { MatDialog } from '@angular/material/dialog';
import { AccountConsentsService } from '../../../account-consents/components/account-consents.service';
import { ApiService } from '../../../core/services/api.service';
import { load, ReCaptchaInstance } from 'recaptcha-v3-enterprise';
import { IsUserDisabled } from '../../interfaces/user-is-enabled';
import { HandsetService } from '../../../core/services/handset.service';
import { ContentDataService } from '../../../liabilities/services/content-data.service';
import { BannerRealtimeService } from '../../../core/services/banner-realtime.service';
import { WarningStoreService } from '../../services/warning-store.service';
import { LoaderButtonType } from '../../../shared/models/loader-button-type.enum';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  standalone: false,
  selector: 'app-login',
  styleUrls: ['./login.component.scss'],
  templateUrl: './login.component.html',
})
export class LoginComponent implements OnInit, OnDestroy {
  error?: string;
  qrUrl?: SafeUrl;
  private objectUrl?: string;

  public errors = [];
  public form = new LoginForm();
  public loading = false;
  public passwordVisible: boolean;
  public ConfigurationState = ConfigurationState;
  private recaptcha: ReCaptchaInstance;
  public submitted = false;

  public errorMessages = {
    tooManyRequests: 'Zbyt dużo prób logowania - spróbuj ponownie za jakiś czas',
    INVALID_CREDENTIALS: 'Nieprawidłowy login lub hasło',
    unknown: 'Wystąpił nieznany błąd. Spróbuj ponownie później.',
  };
  public formName = 'login';
  private formSubscribtion: Subscription;
  showTotp = false;
  imgLoader = false;
  registerTotp = false;

  constructor(
    private authApi: AuthApiService,
    public handsetService: HandsetService,
    private api: ApiService,
    private authStore: AuthStoreService,
    private analytics: AnalyticsService,
    private analyticsFormService: AnalyticsFormService,
    private router: Router,
    private savedUrlService: SavedUrlService,
    private cartSuggestionService: CartSuggestionService,
    private appCookiesService: AppCookiesService,
    private loginService: LoginService,
    private route: ActivatedRoute,
    private onboardingService: OnboardingService,
    private dialog: MatDialog,
    public appConfig: AppConfig,
    private accountConsentsService: AccountConsentsService,
    private contentDataStoreService: ContentDataService,
    private warningStoreService: WarningStoreService,
    private sanitizer: DomSanitizer,
    private bannerRealtime: BannerRealtimeService,
  ) {
    this.authStore.clearData();
  }

  public ngOnInit(): void {
    this.registerRedirectionWithCartSuggestionToken();
    //todo recaptcha
    // this.loadRecaptcha();
    if (this.route.snapshot.queryParams.error) {

    } else {
      this.extractTokensAndLogin();
    }
    this.formSubscribtion = this.form.valueChanges.subscribe(
      () => {
        if (this.submitted) {
          let emailErrors = this.form.email.errors;
          let passwordErrors = this.form.password.errors;

          if (emailErrors?.invalidCredentials) {
            delete emailErrors.invalidCredentials;
            if (Object.keys(emailErrors).length === 0) {
              this.form.email.setErrors(null);
            }
          } else if (passwordErrors?.invalidCredentials) {
            delete passwordErrors.invalidCredentials;
            if (Object.keys(passwordErrors).length === 0) {
              this.form.password.setErrors(null);
            }
          }
        }
      },
    );

  }

  public ngOnDestroy() {
    this.formSubscribtion.unsubscribe();
  }

  private loadRecaptcha() {
    load(this.appConfig.config.recaptcha.siteKey, { explicitRenderParameters: { badge: 'bottomleft' } })
      .then(recaptcha => this.recaptcha = recaptcha)
      .catch(console.error);
  }

  public onSubmit() {
    if (this.showTotp === true && this.registerTotp) {
      this.authApi.registerTotp(this.form.value).subscribe(
        value => {
          this.registerTotp = false;
          this.qrUrl = null;
          this.form.totp.setValue('');
        },
      );
      return;
    }


    this.loading = true;
    this.submitted = true;
    this.form.markAllAsTouched();
    //todo recaptcha
    // this.sendAuthMetrics(this.form.email.value);
    return this.authStore.login(this.form.value).pipe(
      tap(() => this.loginService.trackLoginEvents(this.form.email.value)),
      tap(() => this.contentDataStoreService.init()),
      tap(() => this.warningStoreService.clear()),
      switchMap(() => this.bannerRealtime.ready()),
      switchMap(() => this.authApi.loggedIn()),
      filter((val) => val === null),
      tap(() => {
        this.onboardingService.init().subscribe();
        this.savedUrlService.url = '/dashboard';
      }),
      switchMap(() => this.router.navigateByUrl('/dashboard')),
      tap(() => {
        this.analytics.trackLogin();
        this.appCookiesService.closeBanner();
        this.accountConsentsService.checkIsMigrationConsentActive();
      }),
      catchError(async (errors) => {
        console.log('login-errros');
        console.log(errors);
        if (errors.status === 400 || errors.status === 401) {
          const desc: string = errors?.error?.error_description || '';
          const errorType: string = errors?.error?.error || '';
          if (errorType === 'otp_required') {
            this.showTotp = true;
          } else if (errorType === 'required_actions') {
            this.fetchQrOtp();
          } else if (errorType === 'invalid_grant') {
            this.showTotp = false;
            this.registerTotp = false;
            this.subscribeToUserStatus().subscribe((res) => {
              console.log(res);
              if (res.disabled) {
                this.form.password.setErrors(errors ? { tooManyRequests: true } : null);
              } else {
                this.form.password.setErrors(errors ? { invalidCredentials: true } : null);
                this.form.email.setErrors(errors ? { invalidCredentials: true } : null);
              }
              this.analyticsFormService.sendEventForCaughtError('password', this.formName);
            });
            return;
          }
        }
        this.loading = false;
        return throwError(() => errors);
      }),
    ).subscribe(() => {
      this.loading = false;
    });
  }

  private subscribeToUserStatus(): Observable<IsUserDisabled> {
    return this.authApi.isDisabled(this.form.email.value);
  }

  private sendAuthMetrics(email: string): void {
    const action = 'account_login';
    this.recaptcha.execute(action)
      .then(token => this.api.post('/auth/metrics', { token, action, email }).toPromise().catch(console.error))
      .catch(console.error);
  }


  private registerRedirectionWithCartSuggestionToken(): void {
    const token = this.cartSuggestionService.getCartSuggestionToken();

    if (token && token !== '') {
      this.cartSuggestionService.checkTokenAndRegisterEvent(token);
    }
  }

  private extractTokensAndLogin() {
    const EMAIL = 'email';

    const email = this.route.snapshot.queryParamMap.get(EMAIL);
    if (email) {
      this.form.email.setValue(email);
    }
  }


  public getQueryParams() {
    let queryParams: any = {};
    if (this.form.email.value !== '') {
      queryParams.email = this.form.email.value;
    }
    return queryParams;
  }

  public fetchQrOtp() {
    this.imgLoader = true;
    this.authApi.getOtpQrCode(this.form.value)
      .subscribe({
        next: (blob) => {
          if (blob.type !== 'image/png') {
            this.error = 'Niepoprawny format obrazu.';
            this.loading = false;
            return;
          }
          // posprzątaj poprzedni URL
          if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);

          this.objectUrl = URL.createObjectURL(blob);
          this.qrUrl = this.sanitizer.bypassSecurityTrustUrl(this.objectUrl);
          this.loading = false;
          this.showTotp = true;
          this.registerTotp = true;
          this.imgLoader = false;
        },
        error: (e) => {
          if (e.status === 422) this.error = 'Użytkownik nie istnieje.';
          else if (e.status === 400) this.error = 'Konto wymaga konfiguracji — spróbuj ponownie.';
          else this.error = 'Nie udało się pobrać kodu QR.';
          this.loading = false;
        },
      });
  }


  protected readonly LoaderButtonType = LoaderButtonType;
  protected readonly load = load;
}
